import React, { useState } from 'react';
import { useToast } from '../contexts/ToastContext';
import { useConfirm } from '../contexts/ConfirmContext';

const Profile = () => {
  const { showToast } = useToast();
  const { showConfirm } = useConfirm();

  const [userInfo] = useState({
    name: '董工',
    role: '设备维护工程师',
    department: '设备管理部',
    phone: '138****9088',
    email: 'dong@samsino.com',
    avatar: '👨‍💼'
  });

  const [quickActions] = useState([
    { name: '退出登录', icon: 'fas fa-sign-out-alt', color: 'red' },
    { name: '清除缓存', icon: 'fas fa-trash', color: 'orange' },
    { name: '检查更新', icon: 'fas fa-sync', color: 'blue' },
    { name: '意见反馈', icon: 'fas fa-comment', color: 'green' }
  ]);

  const [settings] = useState([
    { name: '账户设置', icon: 'fas fa-user-cog', color: 'blue' },
    { name: '通知设置', icon: 'fas fa-bell', color: 'orange' },
    { name: '隐私设置', icon: 'fas fa-shield-alt', color: 'green' },
    { name: '语言设置', icon: 'fas fa-globe', color: 'purple' }
  ]);

  const [appInfo] = useState({
    version: 'v1.0.0',
    build: '2025-08-29',
    size: '15.6MB',
    lastUpdate: '2025-08-29'
  });

  const [usageStats] = useState({
    loginDays: 156,
    totalDevices: 162,
    alarmsHandled: 89,
    reportsGenerated: 23
  });

  const handleQuickAction = (action) => {
    if (action === '退出登录') {
      showConfirm('退出登录', '确定要退出登录吗？', () => {
        showToast('正在退出登录...');
      });
    } else if (action === '清除缓存') {
      showConfirm('清除缓存', '确定要清除缓存吗？', () => {
        showToast('正在清除缓存...');
      });
    } else {
      showToast(`正在执行${action}...`);
    }
  };

  const handleSettingItem = (setting) => {
    showToast(`正在打开${setting.name}...`);
  };

  const handleContactSupport = () => {
    showToast('正在连接客服...');
  };

  const handleAboutApp = () => {
    showToast('智维云APP v1.0.0 - 智能设备健康管理平台');
  };

  return (
    <div className="pb-4">
      {/* 顶部状态栏 */}
      <div className="phm-header">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold">个人中心</h1>
            <p className="text-sm opacity-90">账户管理 · 系统设置</p>
          </div>
          <div className="text-right">
            <div className="text-xs opacity-80">在线状态</div>
            <div className="text-sm font-semibold text-success-600">在线</div>
          </div>
        </div>
      </div>

      {/* 用户信息 */}
      <div className="phm-status-card">
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-2xl text-white">
            {userInfo.avatar}
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-800">{userInfo.name}</h3>
            <p className="text-sm text-gray-600">{userInfo.role}</p>
            <p className="text-xs text-gray-500">{userInfo.department}</p>
          </div>
          <button className="px-3 py-1 bg-primary-500 text-white text-xs rounded-lg hover:bg-primary-600 transition-colors">
            编辑资料
          </button>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">手机号码:</span>
              <span className="ml-2 text-gray-800">{userInfo.phone}</span>
            </div>
            <div>
              <span className="text-gray-500">邮箱地址:</span>
              <span className="ml-2 text-gray-800">{userInfo.email}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 使用统计 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">使用统计</h3>
        <div className="phm-metric-grid">
          <div className="phm-metric-item">
            <div className="phm-metric-value text-primary-600">{usageStats.loginDays}</div>
            <div className="phm-metric-label">登录天数</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-success-600">{usageStats.totalDevices}</div>
            <div className="phm-metric-label">管理设备</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-warning-600">{usageStats.alarmsHandled}</div>
            <div className="phm-metric-label">处理报警</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-purple-600">{usageStats.reportsGenerated}</div>
            <div className="phm-metric-label">生成报告</div>
          </div>
        </div>
      </div>

      {/* 快速操作 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">快速操作</h3>
        <div className="grid grid-cols-2 gap-3">
          {quickActions.map((action, index) => (
            <button
              key={index}
              className={`flex items-center justify-center space-x-2 p-3 rounded-lg border transition-colors ${
                action.color === 'red' ? 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100' :
                action.color === 'orange' ? 'bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100' :
                action.color === 'blue' ? 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' :
                'bg-green-50 text-green-700 border-green-200 hover:bg-green-100'
              }`}
              onClick={() => handleQuickAction(action.name)}
            >
              <i className={action.icon}></i>
              <span className="text-sm font-medium">{action.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* 设置选项 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">设置</h3>
        <div className="space-y-3">
          {settings.map((setting, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
              onClick={() => handleSettingItem(setting)}
            >
              <div className="flex items-center space-x-3">
                <i className={`${setting.icon} text-${setting.color}-600`}></i>
                <span className="text-sm text-gray-700">{setting.name}</span>
              </div>
              <i className="fas fa-chevron-right text-gray-400"></i>
            </div>
          ))}
        </div>
      </div>

      {/* 应用信息 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">应用信息</h3>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">版本号:</span>
            <span className="text-gray-800">{appInfo.version}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">构建日期:</span>
            <span className="text-gray-800">{appInfo.build}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">应用大小:</span>
            <span className="text-gray-800">{appInfo.size}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">最后更新:</span>
            <span className="text-gray-800">{appInfo.lastUpdate}</span>
          </div>
        </div>
      </div>

      {/* 帮助与支持 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">帮助与支持</h3>
        <div className="space-y-3">
          <button
            className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={handleContactSupport}
          >
            <div className="flex items-center space-x-3">
              <i className="fas fa-headset text-blue-600"></i>
              <span className="text-sm text-gray-700">联系客服</span>
            </div>
            <i className="fas fa-chevron-right text-gray-400"></i>
          </button>
          <button
            className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={handleAboutApp}
          >
            <div className="flex items-center space-x-3">
              <i className="fas fa-info-circle text-green-600"></i>
              <span className="text-sm text-gray-700">关于应用</span>
            </div>
            <i className="fas fa-chevron-right text-gray-400"></i>
          </button>
        </div>
      </div>

      {/* 版权信息 */}
      <div className="text-center text-xs text-gray-500 mt-4">
        <p>© 2024 智维云·智能设备健康管理平台</p>
        <p className="mt-1">让设备管理更智能，让运维更高效</p>
      </div>
    </div>
  );
};

export default Profile;
